import React,{useEffect, useState} from 'react'
import { useLocation, useParams } from 'react-router-dom';
import { getUserSubEvent } from '../../services/UserServices/UserService';
import PageTitle from '../layouts/PageTitle';
const SubEvents = () => {
 

  const [subEvents,setSubEvents]=useState([]);
 const { id1, id2 } = useParams();   // destructure both ids
 
const location = useLocation();
  const historyData = location.state?.history;
 

  useEffect(() => {
  
     const getSubEvents=async()=>{
      try {
      const res = await getUserSubEvent(id1,id2);
      
    
      setSubEvents(res?.data?.data?.subEvents);
      
    } catch (error) {
      console.error(error?.response?.data?.message);
    }
     }
   if(id1){
      getSubEvents();
   }
  }, []);


  return (
    <div className="qx-page">
         {/* <PageTitle
          motherMenu="User List"
          activeMenu={`        ${historyData?.user?.hostName ?historyData?.user?.hostName:"User"} >  ${historyData?.event?.name ?historyData?.event?.name:"Event"} > Sub Events`}
          pathBack={true}   
        /> */}





 <PageTitle
  breadcrumbs={[
    {
      label: "User List",
      path: "/user-management",
    },
    {
      label: historyData?.user?.hostName || "User",
      path: `/user-details/${id1}`,
      state: {
        history: {
          user: historyData?.user,
        },
      },
    },
    {
      label: historyData?.event?.name || "Event",
      path: `/user_events/${id1}`,
      state: {
        history: {
          user: historyData?.user,
          event: historyData?.event,
        },
      },
    },
    {
      label: "Sub Events",
    },
  ]}
/>

         <h3 className="mb-4  head font-fm" style={{ color: "#27272A" , fontSize: "20px"}}>

      </h3>
  {subEvents.map((s, i) => (
    <div key={i} className="col-md-4 mb-4">
      <div className="      crds  ">
        <div className="card-body cdd">
          <div>
            <p className="fw-semibold mb-1 title">Sub Event name</p>
            <p className="mb-2 name_field">{s.name}</p>
          </div>
          <div>
            <p className="fw-semibold mb-1 title">Time</p>
            <p className="mb-0 name_field">{s.dateTime}</p>
          </div>
        </div>
      </div>
    </div>
  ))}
</div>

  )
}

export default SubEvents
